import { SxProps, Theme } from "@mui/material/styles";
import * as Global from "styles/global/global.styles";

export function subtitle(theme: Theme): SxProps<Theme> {
    return {
        margin: 0,
        textDecoration: "underline",
        fontWeight: "800",
    };
}

export function wrapper(theme: Theme): SxProps<Theme> {
    return {
        backgroundColor: "white",
        zIndex: 5,
        my: 2,
        borderRadius: "15px",
        border: "1px solid black",
        maxWidth: "1200px",
        backgrounColor: "white",
        width: "100%",
    };
}

export function errorWrapper(theme: Theme): SxProps<Theme> {
    return {
        width: "100%",
        textAlign: "center",
        marginBottom: "10px",
    };
}

export function statusWrapper(theme: Theme): SxProps<Theme> {
    return {
        border: "2px solid lightgray",
        backgroundColor: "#f1f1f1",
        padding: "10px",
        borderRadius: "10px",
    };
}

export function statusButton(theme: Theme): SxProps<Theme> {
    return {
        width: "100%",
        maxWidth: "200px",
        margin: "5px",
    };
}

export function statusListButton(theme: Theme): SxProps<Theme> {
    return {
        backgroundColor: "lightgray",
        marginTop: "15px",
        borderRadius: "5px 5px 0 0",
        "&:hover": { backgroundColor: "#bdbdbd" },
    };
}

export function collapsedContent(theme: Theme): SxProps<Theme> {
    return {
        border: "1px solid lightgray",
        backgroundColor: "#f1f1f1",
        borderTop: "none",
        borderRadius: "0 0 5px 5px",
        padding: "10px",
    };
}

export function statusListItem(theme: Theme): SxProps<Theme> {
    return {
        pl: 2,
        paddingBottom: 0,
    };
}

export function statusChipsWrapper(theme: Theme): SxProps<Theme> {
    return {
        display: "grid",
        gridAutoFlow: "column",
        alignItems: "center",
        width: "fit-content",
    };
}

export function statusArrowIcon(theme: Theme): SxProps<Theme> {
    return {
        mx: "10px",
    };
}

export function selectProcessorWrapper(theme: Theme): SxProps<Theme> {
    return {
        marginTop: "15px",
        display: "flex",
        alignItems: "center",
        gap: "10px",
    };
}

export function selectProcessor(theme: Theme): SxProps<Theme> {
    return {
        minWidth: "120px",
        paddingLeft: "10px",
        marginLeft: "10px",
    };
}

export function requestInfoWrapper(theme: Theme): SxProps<Theme> {
    return {
        alignItems: "flex-start",
        padding: "15px",
        width: "unset",
        gridRowGap: "15px",
        // backgroundColor: "#F9F9F9",
        borderRadius: "5px",
    };
}

export function statusDialogTitle(theme: Theme): SxProps<Theme> {
    return {
        m: 0,
        p: 2,
    };
}

export function statusDialogCancelButton(theme: Theme): SxProps<Theme> {
    return {
        backgroundColor: "gray",
        "&:hover": {
            backgroundColor: "#666666",
        },
    };
}

export function closeDialogIconButton(theme: Theme): SxProps<Theme> {
    return {
        position: "absolute",
        right: 8,
        top: 8,
        color: "grey",
        marginTop: "4px",
    };
}

export function downloadWrapper(theme: Theme): SxProps<Theme> {
    return {
        marginTop: "15px",
        display: "flex",
        alignItems: "flex-end",
        gap: "3px",
    };
}
